<template>
    <div class="forms__field--repeater-table__wrapper">
        <table class="forms__field--repeater-table__table">
            <thead class="forms__field--repeater-table__thead">
                <tr>
                    <th class="forms__field--repeater-table__th forms__field--repeater-table__th--drag"></th>
                    <th
                        v-for="subfield in fieldsList"
                        :key="subfield.slug"
                        class="forms__field--repeater-table__th"
                    >
                        {{ subfield.name }}
                    </th>
                    <th class="forms__field--repeater-table__th forms__field--repeater-table__th--actions"></th>
                </tr>
            </thead>
            <Sortable
                :list="items"
                item-key="_id"
                tag="tbody"
                :group="field.group ?? null"
                class="forms__field--repeater-table__tbody"
                @end="(e) => emit('sort-end', e)"
                @add="(e, item) => emit('sort-add', e, item)"
            >
                <template #empty>
                    <tr>
                        <td :colspan="fieldsList.length + 2" class="forms__field--repeater-table__td--empty">
                            {{ lang('fields::fields.repeater.empty') }}
                        </td>
                    </tr>
                </template>
                <template #item="{ element, index }">
                    <tr
                        :key="`${element._id}-${index}`"
                        class="forms__field--repeater-table__tr"
                    >
                        <td class="forms__field--repeater-table__td forms__field--repeater-table__td--drag cursor-grab">
                            <icon icon="hero/solid/ellipsis-vertical" class="w-3 h-3"></icon>
                        </td>
                        <td
                            v-for="subfield in fieldsList"
                            :key="`${element._id}-${subfield.slug}`"
                            class="forms__field--repeater-table__td"
                        >
                            <div v-if="!subfield.condition ? true : solveCondition(subfield.condition, element)">
                                <Field
                                    :id="`${field.slug ?? ''}${subfield.slug}-${element._id ?? index}`"
                                    v-model="element[subfield.slug]"
                                    :field="subfield"
                                    :file="subfield.type === 'file' ? element[subfield.slug] : null"
                                    :dusk="`form-${subfield.slug}`"
                                    :tabindex="tabindex"
                                    :options="subfield.options ? subfield.options : null"
                                    :multiple="numberToBoolean(multiple)"
                                    label-position="none"
                                    :searchable="numberToBoolean(subfield.searchable)"
                                    size="xs"
                                    :repeater-element="element"
                                />
                            </div>
                        </td>
                        <td class="forms__field--repeater-table__td forms__field--repeater-table__td--actions">
                            <button
                                type="button"
                                class="forms__field--repeater-table__remove"
                                @click="emit('remove', index)"
                            >
                                <icon icon="hero/outline/trash" class="w-4 h-4 text-gray-400 hover:text-red-500" />
                            </button>
                        </td>
                    </tr>
                </template>
            </Sortable>
        </table>
    </div>
</template>

<script lang="ts" setup>
import { solveCondition } from '@src/Fields/Pages/conditions';
import { computed } from 'vue';
import Sortable from '@src/Common/Components/Sortable.vue';

const props = defineProps<{
    field: any;
    items: any[];
    tabindex?: number | string | null;
    multiple?: boolean;
    inline?: boolean;
    size?: string;
    labelPosition?: string;
    minusIcon?: string;
}>();

const emit = defineEmits<{
    (event: 'remove', index: number): void;
    (event: 'sort-end', e: any): void;
    (event: 'sort-add', e: any, item: any): void;
}>();

const fieldsList = computed(() => {
    if (!props.field.fields) {
        return [];
    }
    return Object.values(props.field.fields);
});

 const numberToBoolean = (input: number | boolean | string | undefined) => {
    if (typeof input === 'undefined') {
        return false;
    }
    if (typeof input === 'boolean') {
        return input;
    }
    if (typeof input === 'string') {
        return input === '1';
    }
    return input === 1;
};
</script>
